import { Card } from './Card';

export type ChartCardProps = {
  title: string;
  /** Native browser tooltip on the whole card (hover to read). */
  tooltip?: string;
  right?: React.ReactNode;
  height?: number;
  loading?: boolean;
  error?: string;
  children: React.ReactNode;
};

export function ChartCard({
  title,
  tooltip,
  right,
  height = 240,
  loading,
  error,
  children,
}: ChartCardProps) {
  return (
    <Card
      padding="md"
      className={tooltip ? 'flex cursor-help flex-col' : 'flex flex-col'}
      title={tooltip}
    >
      <div className="mb-3 flex items-start justify-between gap-2">
        <h2 className="text-sm font-semibold text-gray-800">{title}</h2>
        {right}
      </div>
      {error && <p className="mb-2 text-sm text-red-600">{error}</p>}
      {loading ? (
        <div
          className="animate-pulse rounded-xl bg-gray-200/60"
          style={{ height, minHeight: height }}
        />
      ) : (
        <div style={{ height, minHeight: height, width: '100%' }}>{children}</div>
      )}
    </Card>
  );
}
